import paymentMethods from '@/constants/paymentMethods';

export default {
    binding: {
        'single': [
            paymentMethods.BLIK,
            paymentMethods.ONLINE,
            paymentMethods.DRUK,
        ],
        'subscription': [
            paymentMethods.CARD,
            paymentMethods.DRUK,
        ]
    },
    isValid(paymentMethod, paymentType) {
        return this.binding[paymentType].includes(paymentMethod);
    }
}
